class MailchimpPopup{
    static instance;

    static getInstance() {
        if (!MailchimpPopup.instance) {
            MailchimpPopup.instance = new MailchimpPopup();
        }
        return MailchimpPopup.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-button-mailchimp.default', ( $scope ) => {
            $scope.find('.opal-button-mailchimp a.elementor-button').magnificPopup({
                type: 'inline',
                removalDelay: 500,
                callbacks: {
                    beforeOpen: function() {
                        this.st.mainClass = this.st.el.attr('data-effect');
                    }
                },
                midClick: true
            });
        } );
    }
}
MailchimpPopup.getInstance();